export default "__VITE_ASSET__CDi0aWsJ__"